import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLPreElement extends HTMLElement { constructor(tagName: string = 'PRE', ownerDocument?: any) { super(tagName, ownerDocument); } }
